<template>
    <dash
        icon="fa fa-users"
        titulo="DESIGNAÇÃO DE GESTORES"
        @click.native="$router.push({ name: 'Gerentes_GestoresDesignados' })"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
